import type { ReportWidgetItem } from '../types';

interface AugmentItemsForTopNParams {
    items: ReportWidgetItem[];
    topCount: number;
    otherChartItemId: string;
    otherColor?: string;
}

interface BuildTopNChartItemsParams {
    items: ReportWidgetItem[];
    totalAmount?: string;
    totalCount?: number;
    topCount: number;
    otherItemId: string;
    otherLabel: string;
    otherColor?: string;
}

export const augmentItemsForTopNOther = ({
    items,
    topCount,
    otherChartItemId,
    otherColor = 'hsl(0, 0%, 86%)',
}: AugmentItemsForTopNParams): ReportWidgetItem[] =>
    items.map((item, index) => {
        const isBeyondTop = index >= topCount;

        if (!isBeyondTop) {
            return item;
        }

        return {
            ...item,
            color: otherColor,
            meta: {
                ...item.meta,
                chartItemId: otherChartItemId,
            },
        };
    });

export const buildTopNChartItemsWithOther = ({
    items,
    totalAmount,
    totalCount,
    topCount,
    otherItemId,
    otherLabel,
    otherColor = 'hsl(0, 0%, 86%)',
}: BuildTopNChartItemsParams): ReportWidgetItem[] => {
    if (!items.length) return [];

    const numericValue = (value: number | string): number =>
        typeof value === 'number'
            ? value
            : Number.parseFloat(String(value)) || 0;

    const itemsTotal = items.reduce(
        (acc, item) => acc + numericValue(item.primaryValue),
        0,
    );

    const topItems = items.slice(0, topCount);

    const displayedTotal = topItems.reduce(
        (acc, item) => acc + numericValue(item.primaryValue),
        0,
    );

    const overallTotal =
        totalAmount == null
            ? itemsTotal
            : Number.parseFloat(totalAmount) || itemsTotal;

    const otherValue = Math.max(0, overallTotal - displayedTotal);
    const aggregatedCount =
        typeof totalCount === 'number'
            ? Math.max(0, totalCount - topCount)
            : undefined;

    if (
        otherValue <= 0 ||
        (typeof aggregatedCount === 'number' && aggregatedCount <= 0)
    ) {
        return topItems;
    }

    const otherItem: ReportWidgetItem = {
        id: otherItemId,
        label: otherLabel,
        primaryValue: otherValue,
        secondaryValues: {},
        meta: {
            isAggregatedOther: true,
            ...(typeof aggregatedCount === 'number' ? { aggregatedCount } : {}),
        },
        color: otherColor,
    };

    return [...topItems, otherItem];
};
